
import { Component, Vue } from 'vue-property-decorator'
import ForceChangePassword from '@/components/templates/ForceChangePassword.vue'
import { UsersApi } from '@/api/methods/UsersApi'
import { ApiConflictAppError } from '@/models/AppErrorClasses'
import PasswordUtils from '@/utils/PasswordUtils'

/**
 * 生徒用初回パスワード変更ページ
 */
@Component({
  components: {
    ForceChangePassword,
  },
})
export default class StudentForceChangePassword extends Vue {
  /**
   * パスワード更新処理
   *
   * @param password パスワード
   * @param confirmPassword パスワード(確認用)
   */
  private async eventUpdatePassword(password: string, confirmPassword: string): Promise<void> {
    this.$loading.start()

    if (password !== confirmPassword) {
      alert('新しいパスワードと確認用パスワードが一致しません。')
      this.$loading.complete()
      return
    }

    // パスワード指定が適切かのチェック
    const errorMessage = PasswordUtils.checkPasswordEnabled(password)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    try {
      // パスワード更新
      await UsersApi.updatePasswordForce(password)
    } catch (error) {
      if (error instanceof ApiConflictAppError) {
        alert('入力されたパスワードは使用できません。再入力してください。')
        this.$loading.complete()
        return
      }

      // 409エラー以外の場合は例外を投げ直し、共通処理に渡す
      this.$loading.complete()
      throw error
    }

    alert('パスワードを変更しました。変更後のパスワードで再度ログインしてください。')

    // 成功時は認証情報を削除しログイン画面に遷移
    this.$appCookies.removeAuth()
    this.$loading.complete()
    await this.$router.push('/student/login')
  }
}
